import {
  Journey,
} from '@dapi/sdk';
import {
  isTravelerOnStandBy,
} from '@refx/ssci-common';
import {
  SsciRoutes,
} from '../../../configuration/routes';
import {
  MenuItemConfig,
} from './overview.config';

/**
 * Helper function to filter menu item elements for stand-by journey
 *
 * @param item
 * @param standByAllowed
 * @param warningsOnBagAllowance
 * @param catalogAllowedForStandBy
 * @returns a boolean
 */
export function standByJourneyMenuItemsFilter(
  item: MenuItemConfig,
  standByAllowed: boolean,
  warningsOnBagAllowance: boolean,
  catalogAllowedForStandBy: boolean): boolean {
  return standByAllowed && item.navigationKey !== SsciRoutes.seatmap
    && (item.navigationKey !== SsciRoutes.baggage || !warningsOnBagAllowance)
    && (item.navigationKey !== SsciRoutes.catalog || catalogAllowedForStandBy);
}

/**
 * Check if a journey is eligible for cancellation or not.
 *
 * @param journey
 */
export function isJourneyEligibleForCancelation(journey: Journey): boolean {
  const atLeastOneTravelerOnStandBy = journey.travelers.some((traveler) => isTravelerOnStandBy(journey, traveler));
  return journey.acceptance.isAccepted || !!journey.acceptance.isPartial || atLeastOneTravelerOnStandBy;
}
